import {Inject, Injectable} from '@angular/core';
import {APP_CONFIG} from '../app-config.constants';
import {IAppConfig} from '../app-config.interface';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment-wrapper';
import {RECAPTCHA_HEADER, RemaxLeadEntity} from '../classes/leads';

@Injectable()
export class LeadsService {

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private http: HttpClient
  ) { }

  async sendLead(lead: RemaxLeadEntity, recaptchaKey: string): Promise<void> {
    if (!lead.officeInfo && !lead.agentInfo && !lead.listingInfo) console.error('Lead should contain at least one of office, agent, or listing info.');

    const headers = new HttpHeaders({[RECAPTCHA_HEADER]: recaptchaKey});
    return await this.http.post<void>(environment.baseServerUrl + this.appConfig.urls.leads.base, lead, {withCredentials: true, headers: headers})
      .toPromise();
  }
}
